/**
 * @module ChartSettingsPanel/DualYAxisValidationContext
 * @description Confirm 时双 Y 轴指标校验错误 — 面板局部态，不进入 ChartSettingsContext
 */

import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

export interface IDualYAxisValidationErrors {
  primary?: string;
  secondary?: string;
}

interface IDualYAxisValidationContextValue {
  errors: IDualYAxisValidationErrors;
  setErrors: (errors: IDualYAxisValidationErrors) => void;
  clearErrors: () => void;
}

const DualYAxisValidationContext =
  createContext<IDualYAxisValidationContextValue | null>(null);

export const DualYAxisValidationProvider: React.FC = ({ children }) => {
  const [errors, setErrorsState] = useState<IDualYAxisValidationErrors>({});

  const setErrors = useCallback((next: IDualYAxisValidationErrors): void => {
    setErrorsState(next);
  }, []);

  const clearErrors = useCallback((): void => {
    setErrorsState({});
  }, []);

  const value = useMemo(
    (): IDualYAxisValidationContextValue => ({
      errors,
      setErrors,
      clearErrors,
    }),
    [errors, setErrors, clearErrors],
  );

  return (
    <DualYAxisValidationContext.Provider value={value}>
      {children}
    </DualYAxisValidationContext.Provider>
  );
};

export function useDualYAxisValidation(): IDualYAxisValidationContextValue {
  const ctx = useContext(DualYAxisValidationContext);
  if (!ctx) {
    throw new Error(
      'useDualYAxisValidation must be used within DualYAxisValidationProvider',
    );
  }
  return ctx;
}
